module.exports = __webpack_public_path__ + "img/biller.bf967c62.webp";